import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchJurusan } from "../api/get-jurusan";
import { columnsJurusan } from "./columns-jurusan";
import { DataTable } from "@/components/ui/data-table";
import React from "react";

export function JurusanTable() {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ["master-jurusan"],
    queryFn: ({ pageParam }) => fetchJurusan({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.is_next) {
        return allPages.length + 1;
      }
      return undefined;
    },
  });

  const jurusanData = React.useMemo(() => {
    const rawData = data?.pages.flatMap((page) => page.datas) || [];
    const uniqueParams = new Map();
    rawData.forEach((item) => {
      uniqueParams.set(item.master_jurusan_id, item);
    });
    return Array.from(uniqueParams.values());
  }, [data]);

  if (isLoading) {
    return <div className="p-6">Loading data jurusan...</div>;
  }

  if (isError) {
    return (
      <div className="p-6 text-red-500">Error: {(error as Error).message}</div>
    );
  }

  return (
    <DataTable
      columns={columnsJurusan}
      data={jurusanData}
      onReachBottom={() => fetchNextPage()}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
    />
  );
}
